import React, { useState, useEffect } from "react";
import notificationsData from "./sampleData.json";
export default function StampCardCheck() {
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [userData, setUserData] = useState(null)
  const freeTurn = notifications.filter((item) => item.content?.en?.content?.row7 === "Now stamp: 0 (updated with 1 free)")
  const freeTurnCount = freeTurn.length;

  const sampleUsers = notificationsData.data.filter((item) => 
    !['E00299',
      'E00001',
      'S00016',
      'E01010',
      'A00008',
      'G01008',
      'G01291',
      'G00196',
      'E02758',
      'G01195',
      'G00367',
      'G00203',
      'G00621',
      'E00985',
      'G01015',
      'G00074',
      'E01633',
      'G00785',
      'E01180',
      'G01006',
      'E00020',
      '694a622e2f4a2c50b0a035c6',
      '681c8298e2df595b05aeddd2'
    ].includes(item.userId)) || [];
  const userUsageList = sampleUsers
    .map((user) => {
      const userNotifications = user.notifications || [];
      const freeTurns = userNotifications.filter(
        (item) => item.content?.content?.row7 === "Now stamp: 0 (updated with 1 free)"
      ).length;

      return {
        userId: user.userId,
        usageCount: userNotifications.length,
        freeTurns,
        latestDate: userNotifications.reduce((latest, item) => {
          const date = item.date || item.createdAt;
          return date && (!latest || new Date(date) > new Date(latest)) ? date : latest;
        }, null),
      };
    })
    .sort((first, second) => second.usageCount - first.usageCount);
  const totalUsage = userUsageList.reduce((total, user) => total + user.usageCount, 0);
  const totalFreeTurns = userUsageList.reduce((total, user) => total + user.freeTurns, 0);
  const topUsers = userUsageList.slice(0, 5);

 const getUserData = async (userId) => {
  setLoading(true);
    // if (!userId) return alert("Please enter User ID");
  try {
      const response = await fetch(`https://azumayavietnam.com/api/user/ec54b2e6-028d-4836-9b5f-519806bfbe0b/${userId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const responseData = await response.json();
      setUserData(responseData.data || []);
       setLoading(false);

    } catch (error) {
      console.error('Error:', error);
       setLoading(false);
  }
};

  const searchNotification = async () => {
  setLoading(true);
    // if (!userId) return alert("Please enter User ID");
  try {
      const response = await fetch(`https://azumayavietnam.com/api/notification/e042b170-5c04-4ecb-9ed3-e572c02af62c/${userData?.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await response.json();
      setNotifications(responseData.data || []);
       setLoading(false);

    } catch (error) {
      console.error('Error:', error);
       setLoading(false); 
  }
};
useEffect(() => {
  if(userData?.id) {
    searchNotification();
  }
},[userId, userData?.id]);

const getColorByRank = (rank) => {
    if (rank === 'bronze') {
      return '#c1866e'; // Bronze gradient
    } else if (rank === 'silver') {
      return '#8f9193'; // Silver gradient
    } else if (rank === 'gold') {
      return '#ffd74e'; // Gold gradient
    } else if (rank === 'diamond') {
      return '#b1b7f6'; // Diamond gradient
    }
    else if (rank === 'platinum') {
      return '#9fe4dc'; // Diamond gradient
    }
    return 'black'; // Default gradient for other ranks
  };
const getGradientByRank = (rank) => {
    if (rank === 'bronze') {
      return 'linear-gradient( #95513e, #e7a688, #a45942)'; // Bronze gradient
    } else if (rank === 'silver') {
      return 'linear-gradient( #f3f3f3, #bcbcba, #f5f5f3, #bcbcba)'; // Silver gradient
    } else if (rank === 'gold') {
      return 'linear-gradient( #ffce41, #f2af23, #e18a07)'; // Gold gradient
    } else if (rank === 'platinum') {
      return 'linear-gradient( #049c9e, #a6f3f5)'; // Diamond gradient
    }
    else if (rank === 'diamond') {
      return  'linear-gradient( #992fd9, #f49190)'; // Diamond gradient
    }
    return 'black'; // Default gradient for other ranks
  };
  return (
    <div className="container" style={{ margin: "40px auto", textAlign: 'left' }} >
      <h2 style={{ marginBottom: 20, fontWeight: "bold" }}>Stamp Card Check</h2>
      
       <div className='mt-5'>
        <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", marginBottom: 24 }}>
          {[
            ["User", userUsageList.length, "Total users"],
            ["Total usage", totalUsage, "Number of stamp card"],
            ["Free turns", totalFreeTurns, "Number of times a card is completed"],
            ["Top user", topUsers[0]?.usageCount || 0, topUsers[0]?.userId || "No data available"],
          ].map(([label, value, note]) => (
            <div key={label} style={{ background: "#13274f", color: "#fff", borderRadius: 14, padding: "18px 20px", minHeight: 112 }}>
              <div style={{ fontSize: 12, opacity: 0.72, textTransform: "uppercase", letterSpacing: ".06em" }}>{label}</div>
              <div style={{ fontSize: 30, fontWeight: 800, margin: "8px 0 4px" }}>{value}</div>
              <div style={{ fontSize: 12, opacity: 0.72, wordBreak: "break-word" }}>{note}</div>
            </div>
          ))}
        </div>

        <div style={{ display: "grid", gap: 24, gridTemplateColumns: "minmax(280px, .9fr) minmax(320px, 1.4fr)" }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 2px 12px rgba(18, 38, 77, 0.08)" }}>
            <h3 style={{ margin: "0 0 16px", color: "#13274f" }}>Top user</h3>
            {topUsers.map((user, index) => (
              <div key={user.userId} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 0", borderBottom: index < topUsers.length - 1 ? "1px solid #edf0f4" : "none", cursor: "pointer" }} onClick={() => getUserData(user.userId)}>
                <div style={{ width: 32, height: 32, borderRadius: "50%", background: index === 0 ? "#ffd74e" : "#eef1f6", display: "grid", placeItems: "center", fontWeight: 800, color: "#13274f" }}>{index + 1}</div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontWeight: 700, color: "#16293b", overflow: "hidden", textOverflow: "ellipsis" }}>{user.userId}</div>
                  <div style={{ fontSize: 12, color: "#7d8ca3" }}>{user.freeTurns} Free turns</div>
                </div>
                <strong style={{ color: "#482979" }}>{user.usageCount} turns</strong>
              </div>
            ))}
          </div>

          <div style={{ background: "#fff", borderRadius: 14, padding: 20, boxShadow: "0 2px 12px rgba(18, 38, 77, 0.08)" }}>
            <h3 style={{ margin: "0 0 16px", color: "#13274f" }}>User list</h3>
            <div style={{ display: "grid", gap: 8, maxHeight: 360, overflowY: "auto" }}>
              {userUsageList
              .map((user, index) => (
                <div key={user.userId} style={{ display: "grid", gridTemplateColumns: "36px minmax(0, 1fr) auto", alignItems: "center", gap: 10, padding: "10px 12px", background: index % 2 === 0 ? "#f7f8fa" : "#fff", borderRadius: 8, cursor: "pointer" }} onClick={() => getUserData(user.userId)}>
                  <span style={{ color: "#7d8ca3", fontSize: 13 }}>#{index + 1}</span>
                  <span style={{ color: "#16293b", fontSize: 14, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{user.userId}</span>
                  <span style={{ color: "#482979", fontWeight: 700, fontSize: 14 }}>{user.usageCount} turns</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='mt-5' style={{ display: "flex", gap: 10, marginBottom: 25 }} >
        <input
          value={userId}
          onKeyDown={(e) => { if (e.key === "Enter") { getUserData(); }}}
          onChange={(e) => setUserId(e.target.value.toUpperCase())}
          placeholder="Enter User ID..."
          style={{ flex: 1, padding: 12, border: "1px solid #ccc", borderRadius: 8, fontSize: 15}}
        />
        <button 
        className="d-block"
        onClick={() => getUserData(userId)} style={{ padding: "12px 25px", background: "#482979", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: "bold", }} >
          {loading ? "Loading..." : "Search"}
        </button>
      </div>

      {userData && (
        <div style={{ background: "#fff", borderRadius: 18, padding: 24, marginBottom: 25, boxShadow: "0 4px 25px rgba(18, 38, 77, 0.08)", maxWidth: 780 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 18, marginBottom: 22 }}>
            <div style={{ width: 72, height: 72, borderRadius: "50%", background: getGradientByRank(userData?.rank), display: "grid", placeItems: "center", color: '#000', fontWeight: 800, fontSize: 24 }}>
              {userData.name ? userData.name.split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase() : "U"}
            </div>
            <div>
              <div style={{ fontSize: 20, fontWeight: 700, color: "#13274f" }}>{userData.gender} {userData.name || "Unknown User"}</div>
              <div style={{ color: "#65778b", marginTop: 4 }}>{userData.email || "No email provided"}</div>
            </div>
            <div style={{ marginLeft: "auto", textAlign: "right" }}>
              <div style={{ fontSize: 12, textTransform: "uppercase", color: "#7d8ca3", letterSpacing: ".08em", marginBottom: 8 }}>
                Rank
              </div>
              <div style={{ display: "inline-flex", textTransform: "uppercase", alignItems: "center", gap: 8, background: "#eef6ff", borderRadius: 999, padding: "8px 14px", color: getColorByRank(userData?.rank), fontWeight: 600, fontSize: 13 }}>
                {userData.rank || "N/A"}
              </div>
            </div>
          </div>

          <div style={{ display: "grid", gap: 16, gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))" }}>
            {[
              ["User ID", userData.userId],
              ["Family Name", userData.familyName],
              ["Given Name", userData.givenName],
              ["Free Turns", freeTurnCount],
            ].map(([label, value]) => (
              <div key={label} style={{ background: "#f7f7f7", borderRadius: 14, padding: 16, minHeight: 88 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#000", marginBottom: 8 }}>
                  {label}
                </div>
                <div style={{ fontSize: 15, color: "#16293b", wordBreak: "break-word" }}>
                  {value || 0}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
       <h2 style={{ marginBottom: 20, fontWeight: "bold" }}>Free Turns Notifications</h2>
      <div className="container">
        <div className="row">
      {freeTurn
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) 
      .map((item) => (
        <div className="col-md-4" key={item._id} >
          <div style={{ background: "#fff", borderRadius: 12,padding: 20, marginBottom: 20,boxShadow: "0 2px 10px rgba(0,0,0,.08)", borderLeft: item.read ? "5px solid #4caf50" : "5px solid #ff9800", }} >
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 15, }} >
            <div style={{ fontSize: 20, fontWeight: "bold", }} >
              {item.content.en.title}
            </div>

            {/* <div style={{ color: item.read ? "#4caf50" : "#ff9800", fontWeight: "bold", }} >
              {item.read ? "Read" : "Unread"}
            </div> */}
          </div>

          <div style={{ color: "#666", marginBottom: 15 }}>
            {new Date(item.createdAt).toLocaleString()}
          </div>

          <div style={{ background: "#f7f7f7", padding: 15, borderRadius: 8, lineHeight: 1.8, }} >
              <div>{item.titleLang.vi}</div>
              <div>{item.content.vi.content.row3}</div>
              <div>{item.content.vi.content.row6}</div>
              <div>{item.content.vi.content.row7}</div>
          </div>

        </div>
        </div>
      ))}

        </div>
      </div>
      <h2 style={{ marginBottom: 20, fontWeight: "bold" }}>All Notifications</h2>
      <div className="container">
        <div className="row">
      {notifications
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) 
      .map((item) => (
        <div className="col-md-4" key={item._id} >
          <div style={{ background: "#fff", borderRadius: 12,padding: 20, marginBottom: 20,boxShadow: "0 2px 10px rgba(0,0,0,.08)", borderLeft: item.read ? "5px solid #4caf50" : "5px solid #ff9800", }} >
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 15, }} >
            <div style={{ fontSize: 20, fontWeight: "bold", }} >
              {item.content.en.title}
            </div>

            <div style={{ color: item.read ? "#4caf50" : "#ff9800", fontWeight: "bold", }} >
              {item.read ? "Read" : "Unread"}
            </div>
          </div>

          <div style={{ color: "#666", marginBottom: 15 }}>
            {new Date(item.createdAt).toLocaleString()}
          </div>

          <div style={{ background: "#f7f7f7", padding: 15, borderRadius: 8, lineHeight: 1.8, }} >
              <div>{item.titleLang.vi}</div>
              <div>{item.content.vi.content.row3}</div>
              <div>{item.content.vi.content.row6}</div>
              <div>{item.content.vi.content.row7}</div>
          </div>

        </div>
        </div>
      ))}

        </div>
      </div>

      {!loading && notifications.length === 0 && (
        <div
          style={{
            textAlign: "center",
            color: "#888",
            marginTop: 60,
          }}
        >
          No notification
        </div>
      )}
    </div>
  );
}